import React, { useMemo, useState, useEffect } from "react";
import {
  A4ExamEditor,
  unwrapSelfContainedHtml,
  buildSelfContainedHtml,
} from "../Components/article-editor";

const QuestionInlineEditor = ({ choosedContent, setContent }) => {
  const cleanedContent = useMemo(
    () => unwrapSelfContainedHtml(choosedContent || "<p></p>"),
    [choosedContent],
  );

  const [editContent, setEditContent] = useState(cleanedContent);

  useEffect(() => {
    setEditContent(cleanedContent);
  }, [cleanedContent]);

  return (
    <div className="bg-white border border-blue-300 rounded-xl shadow-lg p-4 mb-4">
      {/* همان ادیتور اصلی سوال */}
      <A4ExamEditor
        value={editContent}
        onChange={(newValue) => {
          setEditContent(newValue);
          setContent(newValue);
        }}
      />
    </div>
  );
};

export default QuestionInlineEditor;
